module.exports = __webpack_public_path__ + "static/media/team-member-03.f797c9fb.jpg";